export const DASHBOARD_SECTION_CARD_CLASS =
	"overflow-hidden rounded-xl border border-border-primary bg-primary shadow-xs";
